export type DeviceType = 'mobile' | 'tablet' | 'desktop'

// Detects the device type based on screen size and user agent
export const getDeviceType = (): DeviceType => {
  // // Default for SSR
  if (typeof window === 'undefined') {
    return 'desktop'
  }

  const userAgent = navigator.userAgent.toLowerCase()

  const isTablet =
    /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
      userAgent,
    )

  const isMobile =
    /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    )

  // Get screen width
  const width =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth

  if (isTablet || (width >= 768 && width <= 1024)) {
    return 'tablet'
  }

  if (isMobile || width < 768) {
    return 'mobile'
  }

  return 'desktop'
}

export const isSmallerScreen = () => {
  const userAgent = navigator.userAgent.toLowerCase()

  const isTablet =
    /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
      userAgent,
    )

  const isMobile =
    /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    )

  return isTablet || isMobile
}
